import digitalData from 'digital-data';

export function AdblockDetectionAnalytics() {
  const bus = window.LIFE_CYCLE_EVENT_BUS;

  if (!bus || !bus.lifeCycle || typeof bus.lifeCycle.on !== 'function') return;

  let currentAdBlockerStatus = null;
  let lastAppliedStatus = null;
  let preservationActive = false;

  const updateAdblockStatus = (status) => {
    currentAdBlockerStatus = status;
    lastAppliedStatus = status;
    preservationActive = true;

    if (status !== undefined && status !== null) {
      digitalData.page = digitalData.page || {};
      digitalData.page.pageInfo = digitalData.page.pageInfo || {};
      digitalData.page.pageInfo.adBlocker = status;
    }
  };

  const preserveAdBlockerStatus = () => {
    if (!preservationActive || !currentAdBlockerStatus) return;

    if (digitalData?.page?.pageInfo?.adBlocker !== currentAdBlockerStatus) {
      digitalData.page = digitalData.page || {};
      digitalData.page.pageInfo = digitalData.page.pageInfo || {};
      if (currentAdBlockerStatus !== undefined && currentAdBlockerStatus !== null) {
        digitalData.page.pageInfo.adBlocker = currentAdBlockerStatus;
      }

      lastAppliedStatus = currentAdBlockerStatus;
    }
  };

  function testPixel(url) {
    return new Promise((resolve, reject) => {
      const px = new Image();
      let finished = false;

      px.onload = () => {
        finished = true;
        resolve(true);
      };

      px.onerror = () => {
        finished = true;
        resolve(false);
      };

      px.src = url;

      setTimeout(() => {
        if (!finished) {
          reject('timeout');
        }
      }, 3000);
    });
  }

  const runDetection = () => {
    const px1URL = 'https://assets.thdstatic.com/images/v1/eyeo/eyeo_test_asset_1.gif';
    const px2URL = 'https://assets.thdstatic.com/images/v1/eyeo/eyeo_test_asset_2.gif';

    Promise.all([testPixel(px1URL), testPixel(px2URL), isAdBlockerDetected()])
      .then(([px1, px2, isAdblocker]) => {
        let eventName = '';
        let status = '';
        let adBlockerType = null;

        if (px1 === true && px2 === false) {
          eventName = 'AdBlockerDetection.eyeoOptIn';
          status = 'eyeo-opt-in';
          adBlockerType = 'eyeo-opt-in';
        } else if (px1 === false && px2 === false) {
          eventName = 'AdBlockerDetection.eyeoUnexpected';
          status = 'eyeo-unexpected';
          adBlockerType = 'other-adblocker';
        } else {
          if (isAdblocker === true){
            eventName = 'AdBlockerDetection.eyeoOptOut';
            status = 'eyeo-opt-out';
            adBlockerType = 'eyeo-opt-out';
          } else if (isAdblocker === false) {
            eventName = 'AdBlockerDetection.noAdBlockerDetected';
            status = 'no ad blocker detected';
            adBlockerType = 'none';
          }
        }

        updateAdblockStatus(status);

        if (bus.lifeCycle.trigger) {
          bus.lifeCycle.trigger(eventName, {
            usesABP: status === 'eyeo-opt-in' || status === 'eyeo-opt-out',
            adBlockerType,
            detectionMethod: 'pixel-test'
          });
        }

        scheduleDelayedCheck();
      })
      .catch(() => {
        updateAdblockStatus('error');

        if (bus.lifeCycle.trigger) {
          bus.lifeCycle.trigger('AdBlockerDetection.errorDetecting', {
            usesABP: false,
            adBlockerType: null,
            detectionMethod: 'pixel-test'
          });
        }

        scheduleDelayedCheck();
      });
  };

  const criticalEvents = [
    'search.new-products',
    'browse.new-products',
    'pip.new-products',
    'pep.new-products',
    'exchange-homepage.page-load',
    'my-homepage.page-load',
    'pro-homepage.page-load',
    'landing-page.page-load',
    'store-search.search'
  ];

  criticalEvents.forEach(event => {
    bus.lifeCycle.on(event, () => {
      setTimeout(preserveAdBlockerStatus, 25);
    });
  });

  let fallbackCheckCount = 0;
  const maxFallbackChecks = 2;

  const scheduleDelayedCheck = () => {
    fallbackCheckCount = 0;

    const runFallbackCheck = () => {
      if (fallbackCheckCount < maxFallbackChecks && preservationActive) {
        fallbackCheckCount++;
        setTimeout(() => {
          preserveAdBlockerStatus();
          if (fallbackCheckCount < maxFallbackChecks) {
            runFallbackCheck();
          }
        }, 1000 * fallbackCheckCount);
      }
    };

    runFallbackCheck();
  };

  const createDomElement = () =>{
    let div = document.getElementById('eyeo-sponsored');
    if (!div) {
       div = document.createElement('div');
       div.id ='eyeo-sponsored';
       document.body.appendChild(div);
    }
   return div;
  };

  const isAdBlockerDetected = () => {

    return new Promise((resolve) => {
      const divDisplay = window.getComputedStyle(createDomElement()).display;
      const divVisibility = window.getComputedStyle(createDomElement()).visibility;

      if (divDisplay === 'none' || divVisibility === 'hidden') {
        resolve(true);
      }
      else {
        resolve(false);
      }

    });
  };
  runDetection();
}
